// @TODO: RadioGroup - figure out how to handle it better because...this sucks

import { useUIDSeed } from "react-uid";
import { Field } from "formik";
import PropTypes from "prop-types";

import { RadioGroup, radioGroupSizes } from "../Input/components";
import getInputComponent from "./getInputComponent";

const DynamicField = ({ fieldProps = {} }) => {
    const uid = useUIDSeed();
    const { name, type } = fieldProps;

    if (type === "heading") {
        return <h5>{fieldProps?.label}</h5>;
    }

    if (type === "radioGroup") {
        const { options, size, disabled } = fieldProps;
        const radioOptions = options?.map((radioOption) => ({
            name,
            size,
            disabled,
            type: "radio",
            isHiddenRequired: true,
            ...radioOption,
        }));
        return (
            <RadioGroup size={radioGroupSizes[size?.toUpperCase()]} {...fieldProps}>
                {radioOptions?.map((option) => (
                    <Field key={uid(option)} name={name} value={option?.value} type="radio">
                        {({ field, form }) => getInputComponent(option, field, form)}
                    </Field>
                ))}
            </RadioGroup>
        );
    }

    if (type === "async-select") {
        return (
            <Field name={name} type="text">
                {({ field, form }) => getInputComponent(fieldProps, field, form)}
            </Field>
        );
    }

    return (
        <Field name={name} type={type}>
            {({ field, form }) => getInputComponent(fieldProps, field, form)}
        </Field>
    );
};

DynamicField.propTypes = {
    fieldProps: PropTypes.shape({
        name: PropTypes.string,
        type: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.object),
        size: PropTypes.string,
        disabled: PropTypes.bool,
    }).isRequired,
};

export default DynamicField;
